import React from "react";
import "./SideNavButtons.css";

const SideNavButtons = ({
  onPrev,
  onNext,
  prevPageName = "",
  nextPageName = "",
  showPrev = true,
  showNext = true,
  hidden = false,
}) => {
  if (hidden) return null;
  return (
    <>
  {showPrev && (
    <button
      className="kiosk-nav-arrow kiosk-nav-arrow-left"
      onClick={() => {
        window.scrollTo(0, 0);
        onPrev();
      }}
    >
      <span className="nav-text">{prevPageName}</span>
    </button>
  )}

  {showNext && (
    <button
      className="kiosk-nav-arrow kiosk-nav-arrow-right"
      onClick={() => {
        window.scrollTo(0, 0);
        onNext();
      }}
    >
      <span className="nav-text">{nextPageName}</span>
    </button>
  )}
    </>
  );
};

export default SideNavButtons;
